import { useState } from "react";
import { Route, Routes } from "react-router-dom";
import ArticleSection from "./components/ArticleSection";
import CookieBanner from "./components/CookieBanner";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import Navbar from "./components/Navbar";
import RelatedArticles from "./components/RelatedArticles";
import PrivacyPolicy from "./pages/PrivacyPolicy";

export default function App() {
  const [showBanner, setShowBanner] = useState(true);

  return (
    <div>
      <Navbar />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero />
              <ArticleSection />
              <RelatedArticles />
            </>
          }
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
      <Footer />
      <CookieBanner
        isVisible={showBanner}
        onClose={() => setShowBanner(false)}
      />
    </div>
  );
}
